import { Form, Input, message } from 'antd'
import React, { useCallback, useMemo, useState } from 'react'
import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { LOGIN_BY_MOBILE_PWD } from '~/graphqls/gqls'
import { useMutation } from '@apollo/client'
import Cookies from 'js-cookie'
import { MyForm } from '~/components/ui/MyForm'
import { crossLogin, graphQLErrorMessage, AreaCodeEnum } from '~/utils'
import { MyBtn } from '~/components/ui/MyBtn'
import CryptoJS from 'crypto-js'

import { loginByMobilePwd, loginByMobilePwdVariables } from '~/graphqls/types'
import { MyLink } from '~/components/ui/MyLink'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'
import { useDeviceInfo } from '~/hooks/useDeviceInfo'
import AreaCodeSelector, { handleMobileReg } from './AreaCodeSelector'

export const PwdLogin: React.FC<{
  setVisible?: (visible: boolean) => void
  backUrl?: string
}> = observer(({ setVisible, backUrl }) => {
  const { handleSendDeviceInfo } = useDeviceInfo()
  const [isChecked, setIsChecked] = useState(false)
  const [loading, setLoading] = useState(false)
  const { store } = useStores()
  const [mobileType, setMobileType] = useState<AreaCodeEnum>(AreaCodeEnum.CN)

  const [form] = MyForm.useForm()

  const [loginByMobilePwdAction] = useMutation<
    loginByMobilePwd,
    loginByMobilePwdVariables
  >(LOGIN_BY_MOBILE_PWD)

  const onConfirm = useCallback(async () => {
    const formData = await form.validateFields()
    if (!isChecked) {
      message.destroy()
      message.error('请先勾选同意相关协议')
      return
    }

    setLoading(true)

    loginByMobilePwdAction({
      variables: {
        mobile: formData.mobile,
        password: CryptoJS.MD5(formData.password).toString(),
        areaCode: formData.areaCode,
      },
    })
      .then(data => {
        Cookies.set('gate-token', data?.data?.data?.token || '', {
          expires: 365,
        })
        handleSendDeviceInfo()
        passwordSafeCheck()
        setVisible?.(false)
        crossLogin(data.data?.data?.tokenVoucher!, backUrl)
      })
      .catch(error => {
        message.destroy()
        message.error(graphQLErrorMessage(error) || '登录失败')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [form, isChecked])

  const regMobile = useMemo(() => {
    return handleMobileReg(mobileType)
  }, [mobileType])

  function passwordSafeCheck() {
    const value = form.getFieldValue('password')
    const regex =
      /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/
    if (!regex.test(value)) {
      Cookies.set('safe', '1')
    }
  }

  return (
    <>
      <MyForm $dark form={form}>
        <Form.Item
          name="mobile"
          rules={[
            {
              required: true,
              message: '请输入手机号',
            },
            {
              pattern: regMobile,
              message: '请输入正确的手机号',
            },
          ]}
        >
          <Input
            placeholder="手机号"
            addonBefore={
              <AreaCodeSelector onChange={val => setMobileType(val)} />
            }
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password
            placeholder="密码"
            addonAfter={
              <a
                href="#!"
                onClick={e => {
                  e.preventDefault()
                  store.modal?.setResetPwdVisible(true)
                }}
              >
                忘记密码
              </a>
            }
          />
        </Form.Item>

        <div style={{ marginBottom: 18 }}>
          <MyCheckbox
            checked={isChecked}
            onChange={e => setIsChecked(e.target.checked)}
            $dark
          >
            我已阅读并同意《
            <MyLink
              href="/us/user-agreement"
              exist={true}
              className="primary-color"
            >
              用户协议
            </MyLink>
            》和《
            <MyLink href="/us/privacy" exist={true} className="primary-color">
              隐私政策
            </MyLink>
            》
          </MyCheckbox>
        </div>
        <MyBtn
          onClick={onConfirm}
          style={{ marginBottom: 16 }}
          type="primary"
          size="large"
          loading={loading}
          block
        >
          确定
        </MyBtn>
      </MyForm>
    </>
  )
})
